import { render, staticRenderFns } from "./PhoneNumberSubscriptionTransaction.vue?vue&type=template&id=3105a364"
import script from "./PhoneNumberSubscriptionTransaction.vue?vue&type=script&lang=js"
export * from "./PhoneNumberSubscriptionTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports